import { Menu } from './menu.model';

export const verticalMenuItems = [
    new Menu(1, 'Dashboard', '/', null, 'dashboard', null, false, 0, ";admin;local;fornecedor;gestor"),
    new Menu(2, 'Usuários', '/users', null, 'supervisor_account', null, false, 0, "admin;gestor"),
    new Menu(3, 'Fornecedores', '/fornecedores', null, 'account_balance', null, false, 0, "admin;afiliados"),
    new Menu(4, 'Produtos', '/produtos', null, 'account_balance', null, false, 0, ';fornecedor;gestor;'),

    new Menu(45, 'Blank', '/blank', null, 'check_box_outline_blank', null, false, 40, "todos"),
    new Menu(46, 'Page Not Found', '/pagenotfound', null, 'error_outline', null, false, 40, "todos"),
    new Menu(47, 'Error', '/error', null, 'warning', null, false, 40, "todos"),
    new Menu(48, 'Landing', '/landing', null, 'filter', null, false, 40, "todos"),
    //new Menu(50, 'Agenda', '/schedule', null, 'event', null, false, 0),
    new Menu(66, 'Mapas', null, null, 'map', null, true, 0),
    new Menu(67, 'Distribuição das lojas', '/maps/googlemaps', null, 'location_on', null, false, 66, "todos"),

    new Menu(80, 'Acompanhamento Vendas', null, null, 'more_horiz', null, true, 0, 'admin;gestor;fornecedor;afiliado;'),
    new Menu(81, 'Monitorar Pedidos', '/monitor', null, 'web', null, false, 80, "admin;gestor;fornecedor"),
    new Menu(82, 'Estados de Entrega', '/estados', null, 'call-split', null, false, 80, "admin,gestor"),
    new Menu(83, 'Minhas Vendas', '/minhasVendas', null, 'date_range', null, false, 80, "gestor,fornecedor,admin;afiliado;"),
    new Menu(89, 'Dados da Loja', '/dadosLoja', null, 'home', null, false, 80, ";fornecedor;gestor;admin;"),
    new Menu(90, 'Propriedades', null, null, 'phonelink-setup', null, true, 0, "admin;gestor"),
    new Menu(91, 'Página de Apresentação', '/splash', null, 'call-split', null, false, 90, "admin;gestor"),
    new Menu(92, 'Publicidades', '/publicidades', null, 'business', null, false, 90, "admin;gestor"),
    new Menu(93, 'Localidades', '/localidades', null, 'place', null, false, 90, "admin;gestor"),
    new Menu(94, 'Categorias', '/categorias', null, 'group_work', null, false, 90, "admin;gestor"),
    new Menu(95, 'Operações', '/operacoes', null, 'list', null, false, 90, "admin/gestor"),
    new Menu(96, 'Meios Pagamento', '/meiosPagamento', null, 'dns', null, false, 90, "admin/gestor"),
    new Menu(100, 'Serviços', null, null, 'home', null, true, 0, "admin;gestor"),
    new Menu(96, 'Categorias', '/servicosCategorias', null, 'dns', null, false, 100, "admin/gestor"),

    new Menu(200, 'Documentos', null, null, 'receipt', null, true, 0, "admin/gestor"),
    new Menu(201, 'Termo de Privacidade', '/termoPrivacidade', null, 'how_to_reg', null, false, 200, "admin;gestor"),
    new Menu(201, 'Contrato de Adesão Lojista', '/documento/ContratoServico', null, 'how_to_reg', null, false, 200, "admin;gestor"),
    new Menu(202, 'Termo de Serviços do App', '/termoServicos', null, 'rowing', null, false, 200, "admin/gestor"),
    new Menu(203, 'Termo de Adesão de Afiliados', '/termoAfiliados', null, 'rowing', null, false, 200, "admin/gestor"),
    new Menu(204, 'Totalizadores', '/totalizadores', null, 'payment', null, false, 200, "admin;gestor"),
    new Menu(205, 'Configs', '/configs', null, 'engine', null, false, 200, "admin"),
    new Menu(800, 'Monitoramento', null, null, 'phonelink-setup', null, true, 0, 'admin/gestor/afiliado'),
    new Menu(801, 'Não Atendidos', '/naoAtendidos/true', null, 'dns', null, false, 800, 'admin/gestor/afiliado'),


]

export const horizontalMenuItems = verticalMenuItems;


/*
export const horizontalMenuItems = [ 
    new Menu (1, 'Dashboard', '/', null, 'dashboard', null, false, 0),
    new Menu (2, 'Usuários', '/users', null, 'supervisor_account', null, false, 0), 
    new Menu (3,'Fornecedores','/fornecedores',null,'account_balance',null,false,0),
    new Menu (66, 'Maps', null, null, 'map', null, true, 70),
    new Menu (67, 'Google Maps', '/maps/googlemaps', null, 'location_on', null, false, 66),
    new Menu (45, 'Blank', '/blank', null, 'check_box_outline_blank', null, false, 40),
    new Menu (46, 'Page Not Found', '/pagenotfound', null, 'error_outline', null, false, 40),
    new Menu (47, 'Error', '/error', null, 'warning', null, false, 40),
    new Menu (48, 'Landing', '/landing', null, 'filter', null, false, 40),
    new Menu (50, 'Agenda', '/schedule', null, 'event', null, false, 40),
    new Menu (80, 'Monitoramento',null,null,'phonelink-setup',null,true,0),
    new Menu (81, 'Monitor', '/monitor', null, 'web', null, false, 80),
    new Menu (82, 'Estados de Entrega', '/estados', null, 'call-split', null, false, 80),

    new Menu (90, 'Propriedades',null,null,'phonelink-setup',null,true,0),
    new Menu (91, 'Página de Apresentação', '/splash', null, 'call-split', null, false, 90),
    new Menu (92, 'Publicidades', '/publicidades', null, 'business', null, false, 90),
    new Menu (93,'Localidades','/localidades',null,'place',null,false,90),
    new Menu (94,'Categorias','/categorias',null,'dns',null,false,90),
    new Menu (95,'Meios Pagamento','/meiosPagamento',null,'dns',null,false,90),
]
*/